import i18n from '../i18n/i18n.js'
export default {
  WEBSITE_NAME: process.env.VUE_APP_WEBSITE_NAME || 'Lumen IM',
  BASE_API_URL: process.env.VUE_APP_API_BASE_URL || '',
  BASE_WS_URL: process.env.VUE_APP_WEB_SOCKET_URL || '',
  
  
}
//lazada上架失败的错误代码
export const WARNING_CODES={
  '4110':i18n.t("other.a3248"),
  '4112':i18n.t("other.a3249"),
  '0':i18n.t("other.a3250"),
  '4108':i18n.t("other.a3251"),
  '500':i18n.t("other.a3252"),
  '4110':i18n.t("other.a3248"),
  '4110':i18n.t("other.a3248"),
  '4110':i18n.t("other.a3248"),
}

export const COUNTRY_AREA={
  'TH':i18n.t("h5.DSX_index_th"),
  'th':i18n.t("h5.DSX_index_th"),
  'PH':i18n.t("h5.DSX_index_ph"),
  'ph':i18n.t("h5.DSX_index_ph"),
  'VN':i18n.t("h5.DSX_index_vn"),
  'vn':i18n.t("h5.DSX_index_vn"),
  'SG':i18n.t("other.a2232"),
  'sg':i18n.t("other.a2232"),
  'ID':i18n.t("h5.DSX_index_id"),
  'id':i18n.t("h5.DSX_index_id"),
  'TW':i18n.t("h5.DSX_index_tw"),
  'tw':i18n.t("h5.DSX_index_tw"),
  'MY':i18n.t("other.a1092"),
  'my':i18n.t("other.a1092"),
  'BZ':i18n.t("h5.DSX_index_bz"),
  'bz':i18n.t("h5.DSX_index_bz"),
  'CN':i18n.t("other.a2335"),
  'cn':i18n.t("other.a2335"),
  '0':i18n.t("other.a3337"),
  '1':i18n.t("other.a3338"),
  '2':i18n.t("other.a3339"),
  '3':i18n.t("other.a3340"),
  '4':i18n.t("other.a3341"),
  '5':i18n.t("other.a3342"),
}

export const CONUNTYOPTIONS=[{
  label:i18n.t("h5.DSX_index_th"),
  value:'TH'
},{
  label:i18n.t("h5.DSX_index_ph"),
  value:'PH'
},{
  label:i18n.t("h5.DSX_index_vn"),
  value:'VN'
},{
  label:i18n.t("other.a2232"),
  value:'SG'
},{
  label:i18n.t("h5.DSX_index_id"),
  value:'ID'
},{
  label:i18n.t("h5.DSX_index_tw"),
  value:'TW'
},{
  label:i18n.t("other.a1092"),
  value:'MY'
},{
  label:i18n.t("h5.DSX_index_bz"),
  value:'BZ'
},{
  label:i18n.t("other.a2335"),
  value:'CN'
},]


export const ORDER_STATUS={
  'READY_TO_SHIP':i18n.t("other.a2841"),
  'ready_to_ship':i18n.t("other.a2841"),
}

//上架shopee产品时，官方接口返回的错误提示转换
export const SHOPEE_PUBLISH_WARNING={
  'variation name length should less then :20':i18n.t("other.a3253"),
  'Must contains all mandatory attribute':i18n.t("other.a3254"),
  'item upload controller title_len no pass : lowLimit : 20 - UpperLimit : 100  ':i18n.t("other.a3255"),
  'item is duplicate  ':i18n.t("other.a3256"),
  "item upload controller price of the most expensive sku divided by the price of the cheapest sku no pass : actual_value : 10 - UpperLimit : 7  ":i18n.t("other.a3257"),

}
